<template>
  <article class="magazine-gallery-block">
    <a :aria-label="aria">
      <figure class="magazine-gallery-block__image">
        <img :src="getImage" alt="Alt description for the image" />
      </figure>
      <div class="magazine-gallery-block__text">
        <span>Test title Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum quasi modi rem itaque voluptatum exercitationem magni nihil eveniet error dicta inventore expedita voluptate cupiditate iste, hic cum numquam ut reprehenderit!</span>
        <div class="magazine-gallery-block__icon icon-text--secondary">
        <BaseIcon name="chevron_right" size="24" />
      </div>
      </div>
      
    </a>
  </article>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'

export default {
  name: 'CardMagazineGallery',
  components: {
    BaseIcon
  },
  props: {
    title: {
      type: String,
      default: 'View product information & download'
    },
    image: {
      type: String,
      default: 'carrier-bags.jpg'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.magazine-gallery-block {
  @apply overflow-hidden relative p-2 flex-1 self-stretch;
  
}
.magazine-gallery-block a {
  @apply flex h-full overflow-hidden bg-transparent flex-col cursor-pointer;
  border-radius: 1rem;
  box-shadow: .3px .3px 4px -1px rgba(0,0,0,.011),.7px .7px 7.5px -1px rgba(0,0,0,.016),1.3px 1.3px 10.8px -1px rgba(0,0,0,.02),2.2px 2.2px 14.5px -1px rgba(0,0,0,.024),4.2px 4.2px 19.5px -1px rgba(0,0,0,.029),10px 10px 30px -1px rgba(0,0,0,.04);
}
.magazine-gallery-block:hover .magazine-gallery-block__image img {
  transform: scale(1.1);
}
.magazine-gallery-block__text {
  @apply bg-white relative overflow-hidden flex-1 p-3 leading-none flex flex-wrap content-between;  
}
.magazine-gallery-block__text span {
  @apply leading-tight text-base w-full block;  
}
.magazine-gallery-block__image {
  @apply bg-body-dark relative overflow-hidden;
}
.magazine-gallery-block__image img {
  @apply block absolute inset-y-0 inset-x-0 transition-slow object-cover object-center min-h-full min-w-full;
}
.magazine-gallery-block__icon {
  @apply w-8 h-8 flex justify-center items-center rounded-full mt-2;
  background-color:#F6F4ED;
}
.magazine-gallery-block__icon span span:last-of-type {
  @apply text-base text-body text-center;
}
.magazine-gallery-block__icon span.material-icon {
  @apply ml-1;
}
@screen md {
  .magazine-gallery-block {
    @apply p-2;
  }
  .magazine-gallery-block__text {
  @apply p-3;  
}
  .magazine-gallery-block__text span {
  @apply text-base w-full;  
}
.magazine-gallery-block__icon {
  @apply mt-4
}
}
@screen lg {
  .magazine-gallery-block {
    @apply p-4;
  }
.magazine-gallery-block__icon span.material-icon {
  @apply ml-0;
}
.magazine-gallery-block__text {
  @apply p-6;
  }
  .magazine-gallery-block__text span {
  @apply text-lg;  
}
}
@screen xl {
  .magazine-gallery-block__icon span {
    @apply text-xl text-center;
  }
}
</style>
